module.exports = __webpack_public_path__ + "media/images/favicon/mstile-144x144-14db0674247cfad088b11b64e2b7ff10.png";